import { useEffect } from "react"

import { Divider, Typography } from "antd"
import { useDispatch, useSelector } from "react-redux"

import AdminMainTable from "./components/AdminMainTable"
import AdminStatisticsBlock from "./components/AdminStatisticsBlock"
import { getAdminStatisticBlocks } from "./redux/referrals.thunks"

const { Text } = Typography

const ReferralsAdminPage = () => {
  const dispatch = useDispatch()
  const { testData: test_data } = useSelector((state) => state.globalFilters)
  useEffect(() => {
    dispatch(getAdminStatisticBlocks({ test_data }))
  }, [test_data])

  useEffect(() => {
    document.title = "Referrals - Chargeback"
  }, [])

  return (
    <div className="admin-referrals-page">
      <Text className="overview-title">Overview</Text>
      <AdminStatisticsBlock />
      <Divider />
      <AdminMainTable />
    </div>
  )
}

export default ReferralsAdminPage
